import type { Base } from 'active-resource';
import type { GConstructor } from './APILibrary';
import APILibrary, { ClassExtender, GenerateResource } from './APILibrary';
import type { ProfileQuestionResource } from './ProfileQuestion';

export const ONBOARDING_EVENT_VIEWED = 'viewed';
export const ONBOARDING_EVENT_ANSWERED = 'answered';
export const ONBOARDING_EVENT_SKIPPED = 'skipped';

type EventType =
  | typeof ONBOARDING_EVENT_VIEWED
  | typeof ONBOARDING_EVENT_ANSWERED
  | typeof ONBOARDING_EVENT_SKIPPED;

/**
 * Relationship classes
 */
export class OnboardingEventAttributes {
  event: EventType = null;
}

export class OnboardingEventBelongsTo {}

export class OnboardingEventHasOne {
  profileQuestion: ProfileQuestionResource;
}

export class OnboardingEventHasMany {}

/**
 * Utility interfaces
 */
export interface OnboardingEventMethods {}

export interface OnboardingEventInterface
  extends OnboardingEventAttributes,
    OnboardingEventBelongsTo,
    OnboardingEventHasOne,
    OnboardingEventHasMany,
    OnboardingEventType {}

type OnboardingEventType = GConstructor<OnboardingEventInterface>;

export interface OnboardingEventResource
  extends Base<OnboardingEventAttributes>,
    OnboardingEventInterface,
    OnboardingEventMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<OnboardingEventAttributes>({
    queryName: 'onboarding_events',
    className: 'OnboardingEvent',
    AttributesClass: OnboardingEventAttributes,
    BelongsToClasses: [
      {
        Klass: OnboardingEventBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: OnboardingEventHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: OnboardingEventHasMany,
      },
    ],
  });

export const OnboardingEventResourceClass = <TBase extends OnboardingEventType>(
  BaseConstructor: TBase,
) => class extends BaseConstructor implements OnboardingEventMethods {};

export class OnboardingEventResource extends ClassExtender<OnboardingEventInterface>(
  BaseClass,
  OnboardingEventResourceClass,
) {}

/**
 * Resource instance
 */
export const OnboardingEvent =
  APILibrary.createResource<OnboardingEventResource>(OnboardingEventResource);
